import React, { useState, useEffect, useCallback } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  Text, Badge, HStack, Spinner, Center,
} from "@chakra-ui/react";
import { getCrmFicha } from "../../services/api";
import { formatPhone, formatDoc } from "./crmUtils";
import FichaCliente from "./FichaCliente";

const ACCENT = "#F68633";

export default function FichaClienteModal({ clienteId, isOpen, onClose, onAbrirChat, onChanged }) {
  const [ficha, setFicha] = useState(null);
  const [loading, setLoading] = useState(true);

  const carregar = useCallback(async () => {
    if (!clienteId) return;
    setLoading(true);
    const r = await getCrmFicha(clienteId);
    setFicha(r || null);
    setLoading(false);
  }, [clienteId]);

  useEffect(() => { if (isOpen && clienteId) carregar(); }, [isOpen, clienteId, carregar]);

  const conta = ficha?.conta;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl" scrollBehavior="inside" isCentered>
      <ModalOverlay />
      <ModalContent>
        {loading || !ficha ? (
          <Center py={20}><Spinner color={ACCENT} /></Center>
        ) : (
          <>
            <ModalHeader>
              <HStack spacing={2} pr={8}>
                <Text fontSize="lg" noOfLines={1}>{conta.nome || "Sem nome"}</Text>
                {conta.tipo_doc && <Badge colorScheme={conta.tipo_doc === "CNPJ" ? "purple" : "blue"}>{conta.tipo_doc === "CNPJ" ? "PJ" : "PF"}</Badge>}
                {!conta.em_carteira && <Badge colorScheme="gray">fora da carteira</Badge>}
              </HStack>
              <Text fontSize="xs" color="gray.400" fontWeight="normal">
                {conta.documento ? formatDoc(conta.documento) : "sem documento"} · {formatPhone(conta.telefone) || "sem telefone"}{conta.email ? " · " + conta.email : ""}
              </Text>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FichaCliente
                ficha={ficha}
                onReload={carregar}
                onAbrirChat={onAbrirChat}
                onChanged={onChanged}
                onClose={onClose}
              />
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
